"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
const sharing_url_context_1 = require("./sharing-url-context");
const useShareUrl = (defaultUrl) => {
    const { url, urlParams } = (0, sharing_url_context_1.useSharingUrlContext)();
    return (0, react_1.useMemo)(() => {
        const originalUrl = url || defaultUrl || window.location.href;
        if (!urlParams) {
            return originalUrl;
        }
        const { origin, pathname, searchParams } = new URL(originalUrl);
        return `${origin}${(0, libs_next_utils_1.concatPathnameQuery)(pathname, new URLSearchParams(Object.assign(Object.assign({}, Object.fromEntries(searchParams)), Object.fromEntries(urlParams))))}`;
    }, [url, urlParams, defaultUrl]);
};
exports.default = useShareUrl;
//# sourceMappingURL=useShareUrl.js.map